import React from 'react';

const clsMap = {
  ACTIVE: 'bg-emerald-500/15 text-emerald-200 border-emerald-500/40',
  SUSPENDED: 'bg-rose-500/15 text-rose-200 border-rose-500/40',
  TRIAL: 'bg-amber-500/15 text-amber-200 border-amber-500/40',
};

const TenantStatusBadge = ({ status }) => {
  const key = String(status || '').toUpperCase();
  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-medium ${clsMap[key] || 'bg-slate-700/60 text-slate-200 border-slate-600'}`}>
      {key || '-'}
    </span>
  );
};

export default TenantStatusBadge;
